<template>
  <div class="thanks-page">
    <div class="thanks">
      <div class="title-wrapper">
        <h2 class="thanks-title">抽選会はリトル・ママ会員のみ参加できます</h2>
      </div>
      <div>
        <p class="advise">登録は３分でカンタン終了♪</p>
      </div>
      <div>
        <p class="advise">リトル・ママ会員になって抽選会に参加しませんか？</p><br>
      </div>
      <div class="btn-wrapper">
        <button
          type="button"
          class="grayout"
          @click="toRegister()"
        >登録して抽選会に参加</button>
      </div>
      <div class="to-login">
        <a href="https://l-ma.co.jp/login?from=onlinefesta">会員なのでログインする</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toRegister () {
      window.location.href = 'https://l-ma.co.jp/register?from=onlinefesta'
    }
  }
}
</script>

<style>

</style>
